import deprecatedPropType from '@mui/utils/deprecatedPropType';

export default deprecatedPropType;
